import { makeStyles } from "@mui/styles";
import { colors } from "../../../styles/colors";

export default makeStyles({
  containerForm: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginTop: "20px"
  },
  textModalContainer: {
    textAlign: "center",
    padding: "20px 0"
  },
  servicesContainer: {
    marginTop: "16px",
    width: "100%"
  },
  servicesList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    maxHeight: "300px",
    overflowY: "auto",
    padding: "10px 0"
  },
  serviceItem: {
    padding: "8px 0",
    borderBottom: `1px solid ${colors.lightBlue}`
  },
  attachedServicesInfo: {
    padding: "8px 0",
    marginBottom: "12px",
    borderBottom: "1px solid #e0e0e0",
  },
  
  serviceLabelContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    width: "100%",
  },
  
  attachedBadge: {
    backgroundColor: "#4caf50",
    color: "white",
    padding: "2px 6px",
    borderRadius: "12px",
    fontSize: "10px",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  
  serviceCode: {
    color: "#666",
    fontSize: "12px",
    fontStyle: "italic",
  },

  /** Carries a service_code — selecting it can enable "prise de RDV". */
  bookableBadge: {
    backgroundColor: colors.primary,
    color: "white",
    padding: "2px 6px",
    borderRadius: "12px",
    fontSize: "10px",
    fontWeight: "bold",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
  },

  /** No service_code — descriptive only, never bookable. */
  notBookableBadge: {
    backgroundColor: "#e0e0e0",
    color: "#616161",
    padding: "2px 6px",
    borderRadius: "12px",
    fontSize: "10px",
    fontWeight: "bold",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
    cursor: "help",
  },

  rdvBannerOk: {
    marginTop: "12px",
    padding: "10px 12px",
    borderRadius: "8px",
    fontSize: "13px",
    lineHeight: 1.45,
    backgroundColor: "#e8f5e9",
    border: "1px solid #a5d6a7",
    color: "#1b5e20",
  },

  rdvBannerWarn: {
    marginTop: "12px",
    padding: "10px 12px",
    borderRadius: "8px",
    fontSize: "13px",
    lineHeight: 1.45,
    backgroundColor: "#fff8e1",
    border: "1px solid #ffe082",
    color: "#7a4f01",
  },
  
  changesSummary: {
    marginTop: "16px",
    padding: "12px",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  }
});